var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 640,
    viewBox: "0 0 10080 5040",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V1.5H7V3H6zM6,0H3V3.5H0V3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Star7",
    d: "M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star5",
    d: "M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Cstar",
    xlinkHref: "#Star7",
    transform: "scale(2.1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(840)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 6,
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 6,3M6,0 0,3",
    stroke: "#ffffff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 6,3M6,0 0,3",
    stroke: "#e4002b",
    strokeWidth: 0.4,
    clipPath: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0V3.5M0,1.5H7",
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0V3.5M0,1.5H7",
    stroke: "#e4002b",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3H6V0H8V4H0z",
    fill: "#012169"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Comwlth",
    xlinkHref: "#Cstar",
    x: 2520,
    y: 3780
  }), /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Crucis",
    xlinkHref: "#Star7",
    x: 7560,
    y: 4200
  }), /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Crucis",
    xlinkHref: "#Star7",
    x: 6300,
    y: 2205
  }), /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Crucis",
    xlinkHref: "#Star7",
    x: 7560,
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4Crucis",
    xlinkHref: "#Star7",
    x: 8680,
    y: 1869
  }), /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Crucis",
    xlinkHref: "#Star5",
    x: 8064,
    y: 2730
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAu);
export default __webpack_public_path__ + "static/media/Flag_AU.bbbdc0da3c869d490873d282ebd92f78.svg";
export { ForwardRef as ReactComponent };